// Colocated strings for BaseTimeSeriesChart (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a
// LOCAL composer with the warn flags off: these nine keys resolve here, and the card
// title / info text arrive already translated as props.
//
// `today` (AM_ABSORPTION_PLAN step D4) is the opt-in today marker's label — standalone
// asset-management's `today` ("Today"), translated in all 10 files.
//
// `day`/`week`/`month`/`total`/`loading` are lifted verbatim from the app's
// `src/locales.js` (`day`/`week`/`month`/`total`/`loadingData`, present in all 10
// bundles). `resetZoom`, `noData` and `unknown` (S11 bit 2 — the tooltip's fallback
// for a breakdown row with no title, an English literal in setup.js until then)
// existed only in `en` there, or nowhere at all, so they ship as ENGLISH in all 10
// files on purpose — the `loaded` policy: untranslated, but resolving locally, so no
// warning and no chance of a blank. `vi` (the 11th locale, 2026-10-28) shipped with all nine
// translated.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
